"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = previousChapter;

var _isFuzzySecondsEqual = _interopRequireDefault(require("../../isFuzzySecondsEqual"));

var _getCurrentClipIndex = _interopRequireDefault(require("../../clips/getCurrentClipIndex"));

var _updateVideoElement = _interopRequireDefault(require("../updateVideoElement"));

var _normaliseTime = _interopRequireDefault(require("../../normaliseTime"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function stateSelector(_ref) {
  var previousClip = _ref.previousClip,
      shouldStayOnCurrentClip = _ref.shouldStayOnCurrentClip,
      isAtEnd = _ref.isAtEnd,
      currentClip = _ref.currentClip;
  return function (_ref2) {
    var elapsedDuration = _ref2.elapsedDuration;
    return {
      playing: false,
      currentTime: previousClip.startTime,
      currentClip: previousClip,
      elapsedDuration: shouldStayOnCurrentClip && !isAtEnd ? elapsedDuration : (0, _normaliseTime.default)(elapsedDuration - (isAtEnd ? currentClip : previousClip).duration)
    };
  };
}

function onUpdateState(_ref3) {
  var videoEl = _ref3.videoEl,
      shouldStayOnCurrentClip = _ref3.shouldStayOnCurrentClip,
      previousClip = _ref3.previousClip;
  return function () {
    (0, _updateVideoElement.default)({
      videoEl: videoEl,
      newTime: shouldStayOnCurrentClip ? previousClip.clipStartTime : void 0,
      forceScroll: true
    });
  };
}

function previousChapter(_ref4) {
  var currentTime = _ref4.currentTime,
      onPause = _ref4.onPause,
      playableClips = _ref4.playableClips,
      currentClip = _ref4.currentClip,
      playing = _ref4.playing,
      totalDuration = _ref4.totalDuration,
      videoEl = _ref4.videoEl;

  if (playing) {
    onPause();
  }

  var isAtEnd = currentTime === totalDuration;
  var currentClipIndex = (0, _getCurrentClipIndex.default)(playableClips, currentClip);
  var shouldStayOnCurrentClip = !(0, _isFuzzySecondsEqual.default)(currentTime, playableClips[currentClipIndex].startTime);
  var previousClip = shouldStayOnCurrentClip ? playableClips[currentClipIndex] : playableClips[currentClipIndex - 1] || currentClip;
  return [stateSelector({
    previousClip: previousClip,
    shouldStayOnCurrentClip: shouldStayOnCurrentClip,
    isAtEnd: isAtEnd,
    currentClip: currentClip
  }), onUpdateState({
    videoEl: videoEl,
    shouldStayOnCurrentClip: shouldStayOnCurrentClip,
    previousClip: previousClip
  })];
}